export const GET_DASHBOARD_CURRENT_ORGANIZATION_START =
  'GET_DASHBOARD_CURRENT_ORGANIZATION_START';
export const GET_DASHBOARD_CURRENT_ORGANIZATION_END =
  'GET_DASHBOARD_CURRENT_ORGANIZATION_END';
export const GET_DASHBOARD_CURRENT_ORGANIZATION_SUCCESS =
  'GET_DASHBOARD_CURRENT_ORGANIZATION_SUCCESS';
export const GET_DASHBOARD_CURRENT_ORGANIZATION_FAILURE =
  'GET_DASHBOARD_CURRENT_ORGANIZATION_FAILURE';
